import React, { useEffect } from "react";

import { ReactComponent as LeftArrow } from "../../../../../assets/arrow-left.svg";
import { ReactComponent as LeftArrowDark } from "../../../../../assets/arrow-left-dark.svg";
import { Link, useNavigate } from "react-router-dom";
import { useStateContext } from "../../../../../contexts/ThemeContext";

// redux
import { useDispatch, useSelector } from "react-redux";
import {
  creatingYoutubeBlock,
  resetUser,
} from "../../../../../redux/slices/block/createYoutubeBlockSlice";
import { gettingLinkList } from "../../../../../redux/slices/gettingLinksList/gettingLinkListSlice";
import { toast } from "react-hot-toast";

import DividerForm from "../forms/DividerForm";
import useLocales from "../../../../../hooks/useLocales";
import useSettings from "../../../../../hooks/useSettings";

const Divider = () => {
  const { darkMode } = useSelector((state) => state.theme);
  const { translate } = useLocales();
  const { setActiveMainPageNav } = useStateContext();

  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { themeDirection } = useSettings();

  useEffect(() => {
    setActiveMainPageNav(true);

    return () => {
      setActiveMainPageNav(false);
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const blockFeature = useSelector(
    (state) => state?.paymentStripes?.getBlockByPlanId?.response
  );
  const paymenetBlocks = useSelector(
    (state) => state?.paymentStripes?.getBlockByPlanId?.paymenet_blocks
  );
  // Divider
  const dividerCheck = blockFeature?.some(
    (item) => item.name === "divider" && paymenetBlocks === 1
  );

  useEffect(() => {
    if (!dividerCheck) {
      navigate("/pricing");
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  // data needed for calling fetching list
  const user = JSON.parse(localStorage.getItem("user"));
  const userId = user.userid;
  const usertoken = user.token;
  const linkId = localStorage.getItem("linkId");
  const linkListData = {
    userId,
    usertoken,
    linkId,
  };
  const [subLoader, setSubLoader] = React.useState(false);

  const handleDividerSubmit = async (color, language) => {
    setSubLoader(true);
    const state = {
      coloumnType: "divider",
      coloumnValue: { divider: "divider", color: color },
      columnName: "divider",
      language: language
    };
    await dispatch(creatingYoutubeBlock(state));
    setSubLoader(false);
    fetchingLinksList(); // fetching link list after submiting , so list become refresh
  };

  const fetchingLinksList = () => {
    dispatch(gettingLinkList(linkListData));
  };

  const { isYoutubeBlockError, isYoutubeBlockSuccess, isYoutubeBlockLoading } =
    useSelector((state) => state?.youtubeBlock);
  const { status, message } = useSelector(
    (state) => state?.youtubeBlock?.youtubeBlock
  );

  useEffect(() => {
    if (status === "success" && isYoutubeBlockSuccess) {
      toast.success(message);
      navigate("/dashboard");
    }
    if (status === "failed" && isYoutubeBlockSuccess) {
      toast.error(message);
    }
    dispatch(resetUser());
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [
    isYoutubeBlockError,
    isYoutubeBlockSuccess,
    dispatch,
    isYoutubeBlockLoading,
  ]);

  return (
    <>
      <div className="px-6 md:px-0 mt-[37px] md:mt-0 flex items-center justify-between">
        <Link to={"/dashboard/component"}>
          <div className="flex text-body_copy2 items-center cursor-pointer gap-2">
            <div>
              {darkMode ? (
                <LeftArrowDark
                  className={`${
                    themeDirection === "rtl" ? "transform -scale-x-100" : ""
                  }`}
                />
              ) : (
                <LeftArrow
                  className={`${
                    themeDirection === "rtl" ? "transform -scale-x-100" : ""
                  }`}
                />
              )}
            </div>
            <p className="dark:text-color_v1_dark">
              {translate("miscellaneous.divider")}
            </p>
          </div>
        </Link>
      </div>
      <DividerForm
        formType={"add"}
        submitHandlerParent={handleDividerSubmit}
        isLoading={subLoader}
      />
    </>
  );
};

export default Divider;
